import { yarboProducts, YarboProduct } from './yarboProducts'

export type ProductCategory = string
export type Season = string
export type StockStatus = 'in-stock' | 'pre-order' | 'notify'

export interface Product extends YarboProduct {
  category: ProductCategory
  season: Season[]
  status: StockStatus
  shortDescription: string
  features: string[]
  includes: string[]
  image: string
  isPopular?: boolean
}

// Map primaryGroup to the legacy plural categories
const mapCategory = (primaryGroup?: string): string => {
  if (primaryGroup === 'Complete System') return 'Complete Systems'
  if (primaryGroup === 'Bundle') return 'Bundles'
  if (primaryGroup === 'Module') return 'Modules'
  if (primaryGroup === 'Accessory') return 'Accessories'
  return 'Accessories'
}

// Adapter: Map YarboProduct to the legacy Product interface
export const products: Product[] = yarboProducts.map((yp) => {
  const features: string[] = []
  const includes: string[] = []

  let shortDesc = yp.descriptionText || ''
  if (shortDesc.length > 150) {
    shortDesc = shortDesc.substring(0, 147) + '...'
  }

  return {
    ...yp,
    category: mapCategory(yp.primaryGroup),
    season: yp.taskCategories || [],
    status: 'in-stock', // Rule: Treat all visible products as In Stock
    shortDescription: shortDesc,
    features,
    includes,
    image: yp.imageUrl || '',
    isPopular: yp.isCompleteSystem || yp.isBundle,
  }
})

export const getProductBySlug = (slug: string) =>
  products.find((p) => p.slug === slug)

export const getProductsByCategory = (category: string) =>
  products.filter(
    (p) =>
      p.publicCategories?.includes(category) ||
      p.category === category ||
      p.primaryGroup === category,
  )

export const getProductsBySeason = (season: string) =>
  products.filter(
    (p) => p.taskCategories?.includes(season) || p.season.includes(season),
  )

export const getPopularProducts = () => products.filter((p) => p.isPopular)

// Stock status helpers
export const stockLabel = (status: StockStatus) => 'In Stock'

export const ctaLabel = (status: StockStatus) => 'Add to Cart'
